import { helloWorld } from "./hello-world";
import "./buttons";
import "./gf-live-validation";
import "./file-upload";
import "./embla";
import { initIoReveal } from "./io-reveal";

helloWorld("from boilerplate");
initIoReveal();

// Lazy-load the globe bundle when a page contains #globe-demo. Code-split so
// the three.js+globe.gl payload stays out of the global app bundle, and so the
// module loads on htmx-boost navigation (idiomorph won't execute morphed-in
// <script> tags, but a dynamic import() always works).
let globeMod: typeof import("./globe-demo") | null = null;
async function maybeLoadGlobe(): Promise<void> {
  if (!document.getElementById("globe-demo")) return;
  if (!globeMod) globeMod = await import("./globe-demo");
  globeMod.initGlobe();
}
document.addEventListener("DOMContentLoaded", maybeLoadGlobe);
document.addEventListener("htmx:load", maybeLoadGlobe);

let mapMod: typeof import("./map") | null = null;
async function maybeLoadMap(): Promise<void> {
  if (!document.getElementById("map")) return;
  if (!mapMod) mapMod = await import("./map");
  await mapMod.tryInitMap();
}
document.addEventListener("DOMContentLoaded", maybeLoadMap);
document.addEventListener("htmx:load", maybeLoadMap);
